import { Grid, TextField } from "@material-ui/core";
import { InputAdornment } from "@mui/material";
import RegularButton from "components/CustomButtons/Button";
import { ModalV2 } from "components/Modal/ModalV2";
import React from "react";

export const KgsBulkForm = ({
  open,
  onClose,
  disabled,
  handleEndEndowments,
  kgBulk,
  resetOnClick,
}) => {
  return (
    <ModalV2 title="Kilos a Granel" open={open} onClose={onClose} justConfirm>
      <Grid item xs={12}>
        <TextField
          label="Kg Granel:"
          margin="dense"
          variant="outlined"
          fullWidth
          name="kgBulk"
          value={kgBulk}
          onChange={(e) => handleEndEndowments(e, true)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end" style={{ marginLeft: 8 }}>
                Kg
              </InputAdornment>
            ),
          }}
          inputProps={{
            min: 0,
            style: {
              textAlign: "right",
            },
          }}
          disabled={disabled}
          onFocus={() => resetOnClick(handleEndEndowments, kgBulk, "kgBulk")}
        />
      </Grid>
      <Grid item xs={12}>
        <RegularButton color="white" onClick={onClose} fullWidth>
          Cerrar
        </RegularButton>
      </Grid>
    </ModalV2>
  );
};
